/**
 * Journey origin for `post_scheduled.entry_source` — the surface where the
 * user *started* this scheduling intent, independent of where the Schedule
 * button was ultimately tapped (which is `source`). Threaded through
 * `location.state.entry_source` on every navigation that crosses surfaces.
 *
 * Distinct from `home_post_modal_opened.entry_source` (the IMMEDIATE opener of
 * PostModal) — same vocabulary, different semantic. See PostModal's `openedFrom`
 * vs `entrySource` props for the split.
 */
export type PostEntrySource =
  | 'home_idea_card'
  | 'posts_drafts'
  | 'calendar_entry'
  | 'calendar_create'
  | 'cockpit'
  | 'composer_direct'
  | 'assistant_chat'
  | 'post_arrival'
  | 'byo_upload'

const VALID: ReadonlySet<PostEntrySource> = new Set([
  'home_idea_card',
  'posts_drafts',
  'calendar_entry',
  'calendar_create',
  'cockpit',
  'composer_direct',
  'assistant_chat',
  'post_arrival',
  'byo_upload',
])

export function entrySourceFromLocationState(state: unknown): PostEntrySource | undefined {
  if (!state || typeof state !== 'object') return undefined
  const value = (state as { entry_source?: unknown }).entry_source
  return typeof value === 'string' && VALID.has(value as PostEntrySource)
    ? (value as PostEntrySource)
    : undefined
}
